<template>
  <div
    class="step"
    :class="{ active: selectedOrganization && selectedPlatform }"
  >
    <BaseIcon glyph="platform" width="32px" class="mb-s" />
    <p class="mb-xs fw-700">Шаг 3</p>
    <p class="step-description">
      Выбрать организацию и&nbsp;уточнить данные кружка.
    </p>
    <div v-if="user" class="info-block">
      <StepInfo
        class="mt-s"
        :is-done="!!selectedOrganization && !!selectedPlatform"
      />
      <StepInfo
        class="mt-s"
        :info-text="
          selectedOrganization && selectedPlatform
            ? 'Площадка выбрана'
            : 'Уточните данные'
        "
        :is-success="!!selectedOrganization && !!selectedPlatform"
      />
      <BaseButton
        :tag="!selectedPlatform ? 'a' : 'button'"
        href="#org-select"
        class="mt-s"
        size="xs"
        shape="square"
        :disabled="!organizations.length"
        @click="handleClick"
        >{{ buttonText }}</BaseButton
      >
    </div>
  </div>
</template>

<script>
import StepInfo from "@/components/StepInfo";
export default {
  name: "PlatformStep",
  components: {
    StepInfo,
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    selectedOrganization() {
      return this.$store.state.requestPreparing.selectedOrganization;
    },
    selectedPlatform() {
      return this.$store.state.requestPreparing.selectedPlatform;
    },
    organizations() {
      return this.$store.state.requestPreparing.organizations;
    },
    buttonText() {
      if (this.selectedPlatform) {
        return "Посмотреть детали";
      }
      return "Выбрать организацию";
    },
  },
  methods: {
    handleClick() {
      if (!this.selectedPlatform) return;
      this.$emit("openModal");
    },
  },
};
</script>

<style lang="less" scoped>
.step {
  padding: 20px;
  width: 100%;
  border-radius: @border-radius-xs;
  border: 1px solid @blue-color;
  background-color: #fff;
  color: @primary-color;
  display: flex;
  flex-direction: column;

  &-description {
    color: @base-color;
  }

  &.active {
    background-color: @background-blue;
    border-color: @info-color;
    color: @base-color;
  }
}

.info-block {
  margin-top: auto;
}

@media (max-width: @screen-xs-max) {
  .step {
    max-width: 100%;
  }
}
</style>
